import {Outlet, useParams} from 'react-router-dom';
import {Status} from '../../enums/status';
import {useAppSelector} from '../../store/store';
import styles from './notifications.module.scss';
import {NotificationsList} from './notifications_list';
import {CenteredSpinner} from '../../components/spinner/centered_spinner';
import {Main} from '../../components/main/main.tsx';
import mainStyles from '../../components/main/main.module.scss';
import {classNames} from '../../support/classnames.ts';

export function Notifications() {
    const notificationsData = useAppSelector((state) => state.notifications);
    const params = useParams<'notificationId'>();

    if (notificationsData.status !== Status.FULFILLED) {
        return <CenteredSpinner />;
    }

    return (
        <Main className={classNames(mainStyles.bg_white, mainStyles.hide_overflow)}>
            <div
                className={classNames(styles.notifications, {
                    [styles.active]: params.notificationId !== undefined,
                })}
            >
                <NotificationsList />
                <Outlet />
            </div>
        </Main>
    );
}
